<lin-progress-bar [isShown]="!dataSource || (dataSource.isLoading$ | async)"></lin-progress-bar>
<form [formGroup]="form">
  <div class="scrollable-table-container device-list-wrapper">
    <lin-table [dataSource]="dataSource" matSort>
      <!-- Select Column -->
      @if (isAdminOrReseller) {
        <ng-container matColumnDef="select" sticky>
          <mat-header-cell *matHeaderCellDef class="g-table-column-checkbox"></mat-header-cell>
          <mat-cell *matCellDef="let device" class="g-table-column-checkbox">
            <mat-checkbox (change)="handleSelectDevice(device)" [checked]="selectedDevices.has(device.id)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select-search" sticky>
          <mat-header-cell *matHeaderCellDef class="g-table-column-checkbox"></mat-header-cell>
        </ng-container>
      }

      <!-- IMEI Column -->
      <lin-table-column name="imei" [label]="'ADMIN.DEVICES.IMEI' | translate" sticky>
        <ng-container *ng="let device">
          <lin-cell-link [routerLink]="getEditDeviceLink(device.id)"> {{ device.imei }} </lin-cell-link>
        </ng-container>
      </lin-table-column>

      <lin-table-header-control name="imei-search" sticky>
        <input matInput formControlName="imei" autocomplete="off" />
      </lin-table-header-control>

      <!-- IMSI Column -->
      <lin-table-column name="imsi" [label]="'ADMIN.DEVICES.IMSI' | translate">
        <lin-cell-text *ng="let device">{{ device.imsi }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="imsi-search">
        <input matInput formControlName="imsi" autocomplete="off" />
      </lin-table-header-control>

      <!-- ICCID Column -->
      <lin-table-column name="iccid">
        <lin-cell-text *ng="let device">{{ device.iccid }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="iccid-search">
        <input matInput formControlName="iccid" autocomplete="off" />
      </lin-table-header-control>

      <!-- Phone Number Column -->
      <lin-table-column name="phone" [label]="'ADMIN.DEVICES.PHONE_NUMBER' | translate">
        <lin-cell-text *ng="let device">{{ device.phone }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="phone-search">
        <input matInput formControlName="phone" autocomplete="off" />
      </lin-table-header-control>

      <!-- Client Column -->
      <lin-table-column name="client" [label]="'ADMIN.DEVICES.CLIENT' | translate">
        <ng-container *matCellDef="let device">
          @if (!(isReseller && device.team.type === 'reseller' || resellerId && !device.team.clientName || device.team.type === 'admin')) {
            <lin-cell-link
              (click)="openClientInNewTab(device.team.type, device.team.clientId, device.team.resellerId)"
            >
              {{ device.team.clientName || device.team.resellerName }}
            </lin-cell-link>
          } @else {
            <lin-cell-text>-</lin-cell-text>
          }
        </ng-container>
      </lin-table-column>

      <lin-table-header-control name="client-search">
        <input matInput formControlName="client" autocomplete="off" />
      </lin-table-header-control>

      <!-- Reseller Column -->
      <lin-table-column name="reseller" [label]="'ADMIN.RESELLERS.RESELLER'">
        <lin-cell-text *ng="let device">{{ device.reseller?.companyName }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="reseller-search">
        <input matInput formControlName="reseller" autocomplete="off" />
      </lin-table-header-control>

      <!-- Chevron Account ID Column -->
      @if (showChevronIdColumn) {
        <lin-table-column name="chevronAccountId">
          <lin-cell-text *ng="let device">{{ device.team?.chevronAccountId }}</lin-cell-text>
        </lin-table-column>

        <lin-table-header-control name="chevronAccountId-search">
          <input matInput formControlName="chevronAccountId" autocomplete="off" />
        </lin-table-header-control>
      }

      <!-- Plan Column -->
      <lin-table-column name="plan">
        <lin-cell-text *ng="let device">{{ device.plan?.displayName }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="plan-search">
        <mat-select formControlName="plan">
          <mat-option></mat-option>
          @for (plan of plans; track plan.name) {
            <mat-option [value]="plan.name">{{ plan.displayName }}</mat-option>
          }
        </mat-select>
      </lin-table-header-control>

      <!-- Vendor Column -->
      <lin-table-column name="vendor" [label]="'ADMIN.DEVICES.VENDOR' | translate">
        <lin-cell-text *ng="let device">{{ device.vendor.name }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="vendor-search">
        <input matInput formControlName="vendor" autocomplete="off" />
      </lin-table-header-control>

      <!-- Model Column -->
      <lin-table-column name="model" [label]="'ADMIN.DEVICES.MODEL' | translate">
        <lin-cell-text *ng="let device">{{ device.model.name }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="model-search">
        <input matInput formControlName="model" autocomplete="off" />
      </lin-table-header-control>

      <!-- Usage -->
      <lin-table-column name="usage" [label]="'ADMIN.DEVICES.USAGE' | translate">
        <lin-cell-text *ng="let device">{{ DeviceUsageLabel[device.usage] | translate }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="usage-search">
        <mat-select formControlName="usage">
          <mat-option></mat-option>
          @for (usage of DeviceUsageLabel | keys; track usage) {
            <mat-option [value]="usage">{{ DeviceUsageLabel[usage] | translate }}</mat-option>
          }
        </mat-select>
      </lin-table-header-control>

      <!-- Vehicle Column -->
      <lin-table-column name="vehicleRegNo" [label]="'ADMIN.DEVICES.VEHICLE_REG_NUMBER' | translate">
        <lin-cell-text *ng="let device">{{ device.deviceInstallation?.vehicle?.regNo }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="vehicleRegNo-search">
        <input matInput formControlName="vehicleRegNo" autocomplete="off" />
      </lin-table-header-control>

      <!-- Vehicle Status Column -->
      <lin-table-column name="status" [label]="'FIELDS.status' | translate">
        <lin-cell-text *ng="let device">{{ DeviceStatusLabel[device.status] | translate }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="status-search">
        <mat-select formControlName="status">
          <mat-option></mat-option>
          @for (status of DeviceStatusLabel | keys; track status) {
            <mat-option [value]="status">
              {{ DeviceStatusLabel[status] | translate }}
            </mat-option>
          }
        </mat-select>
      </lin-table-header-control>

      <!-- Device Status Column -->
      <lin-table-column name="statusExt" [label]="'FIELDS.statusExt' | translate">
        <lin-cell-text [ngClass]="device.statusExt + '-status-label'" *ng="let device">
          {{ DeviceStatusExtLabel[device.statusExt] | translate | uppercase }}
        </lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="statusExt-search">
        <mat-select formControlName="statusExt">
          <mat-option></mat-option>
          @for (status of DeviceStatusExtLabel | keys; track status) {
            <mat-option [value]="status">{{ DeviceStatusExtLabel[status] | translate }}</mat-option>
          }
        </mat-select>
      </lin-table-header-control>

      <!-- Activity Column -->
      <lin-table-column name="isDeactivated" [label]="'ADMIN.DEVICES.ACTIVITY' | translate">
        <lin-cell-text *ng="let device">{{ DeviceActivityLabel[+device.isDeactivated]| translate }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="isDeactivated-search">
        <mat-select formControlName="isDeactivated">
          <mat-option></mat-option>
          @for (activity of DeviceActivityLabel | keys; track activity) {
            <mat-option [value]="!!(+activity)">
              {{ DeviceActivityLabel[activity] | translate }}
            </mat-option>
          }
        </mat-select>
      </lin-table-header-control>

      <!-- Installed Date Column -->
      <lin-table-column name="installDate" [label]="'ADMIN.DEVICES.INSTALLED_DATE' | translate">
        <lin-cell-text *ng="let device">{{ device.deviceInstallation?.installDate | dayjsDateTime }}</lin-cell-text>
      </lin-table-column>

      <ng-container matColumnDef="installDate-search">
        <mat-header-cell *matHeaderCellDef>
          <lin-datepicker-field formControlName="installDate" [isRange]="true" [isWithTimePicker]="true"></lin-datepicker-field>
        </mat-header-cell>
      </ng-container>

      <!-- Added To Team Column -->
      <lin-table-column name="addedToTeam" [label]="'ADMIN.DEVICES.DEVICE_ADDED' | translate">
        <lin-cell-text *ng="let device">{{ device.addedToTeam || '' | dayjsDate }}</lin-cell-text>
      </lin-table-column>

      <ng-container matColumnDef="addedToTeam-search">
        <mat-header-cell *matHeaderCellDef>
          <lin-datepicker-field formControlName="addedToTeam" [isRange]="true"></lin-datepicker-field>
        </mat-header-cell>
      </ng-container>

      <!-- Ownership Column -->
      <lin-table-column name="ownership">
        <lin-cell-text *ng="let device">{{ DeviceOwnershipLabel[device.ownership] | translate }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="ownership-search">
        <mat-select formControlName="ownership">
          <mat-option></mat-option>
          @for (ownership of DeviceOwnershipLabel | keys; track ownership) {
            <mat-option [value]="ownership">{{ DeviceOwnershipLabel[ownership] | translate }}</mat-option>
          }
        </mat-select>
      </lin-table-header-control>

      <!-- Contract Start at Column -->
      <lin-table-column name="contractStartAt">
        <lin-cell-text *ng="let device">{{ device.contractStartAt | dayjsDate }}</lin-cell-text>
      </lin-table-column>

      <ng-container matColumnDef="contractStartAt-search">
        <mat-header-cell *matHeaderCellDef>
          <lin-datepicker-field formControlName="contractStartAt" [isRange]="true" [isNoMaxDate]="true"></lin-datepicker-field>
        </mat-header-cell>
      </ng-container>

      <!-- Contract Finish at Column -->
      <lin-table-column name="contractFinishAt" [label]="'ADMIN.DEVICES.CONTRACT_ENDS' | translate">
        <lin-cell-text *ng="let device">{{ device.contractFinishAt | dayjsDate }}</lin-cell-text>
      </lin-table-column>

      <ng-container matColumnDef="contractFinishAt-search">
        <mat-header-cell *matHeaderCellDef>
          <lin-datepicker-field formControlName="contractFinishAt" [isRange]="true" [isNoMaxDate]="true"></lin-datepicker-field>
        </mat-header-cell>
      </ng-container>

      <!-- Contract ID Column -->
      <lin-table-column name="contractId" [label]="'ADMIN.DEVICES.CONTRACT_ID' | translate">
        <lin-cell-text *ng="let device">{{ device.contractId }}</lin-cell-text>
      </lin-table-column>

      <lin-table-header-control name="contractId-search">
        <input matInput formControlName="contractId" autocomplete="off" />
      </lin-table-header-control>

      <!-- Last Active Time Column -->
      <lin-table-column name="lastDataReceivedAt" [label]="'ADMIN.DEVICES.LAST_ACTIVE_TIME' | translate">
        <lin-cell-text *ng="let device">{{ device.lastDataReceivedAt | dayjsDateTime }}</lin-cell-text>
      </lin-table-column>

      <ng-container matColumnDef="lastDataReceivedAt-search">
        <mat-header-cell *matHeaderCellDef>
          <lin-datepicker-field formControlName="lastDataReceivedAt" [isRange]="true" [isWithTimePicker]="true"></lin-datepicker-field>
        </mat-header-cell>
      </ng-container>

      <!-- Device deactivation date Column -->
      @if (showDeviceDeactivationDate) {
        <lin-table-column name="deactivatedAt">
          <lin-cell-text *ng="let device">{{ device.deactivatedAt | dayjsDateTime }}</lin-cell-text>
        </lin-table-column>

        <ng-container matColumnDef="deactivatedAt-search">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
        </ng-container>
      }

      <!-- Edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'ADMIN.DEVICES.EDIT' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let device" class="g-table-column-icon">
          <button
            mat-icon-button
            [routerLink]="getEditDeviceLink(device.id)"
            [matTooltip]="'ADMIN.DEVICES.EDIT' | translate"
            data-testid="btn-edit-device"
          >
            <mat-icon svgIcon="edit"></mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit-search">
        <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
      </ng-container>

      <!-- Install Column -->
      <ng-container matColumnDef="install">
        <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'ADMIN.DEVICES.INSTALL' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let device" class="g-table-column-icon">
          <button
            mat-icon-button
            [class.g-disabled]="device.deviceInstallation || device.status === DeviceStatus.Unavailable"
            (click)="openInstallationDialog(device, true)"
            [matTooltip]="'ADMIN.DEVICES.INSTALL' | translate"
            data-testid="btn-install-device"
          >
            <mat-icon svgIcon="add_circle"></mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="install-search">
        <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
      </ng-container>

      <!-- Uninstall Column -->
      <ng-container matColumnDef="uninstall">
        <mat-header-cell *matHeaderCellDef class="g-table-column-icon">{{ 'ADMIN.DEVICES.UNINSTALL' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let device" class="g-table-column-icon">
          <button
            mat-icon-button
            [class.g-disabled]="!device.deviceInstallation"
            (click)="openInstallationDialog(device)"
            [matTooltip]="'ADMIN.DEVICES.UNINSTALL' | translate"
            data-testid="btn-uninstall-device"
          >
            <mat-icon svgIcon="remove_circle"></mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="uninstall-search">
        <mat-header-cell *matHeaderCellDef class="g-table-column-icon"></mat-header-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="settings.columnsDisplayed; sticky: true"></mat-header-row>
      <mat-header-row *matHeaderRowDef="settings.columnsSearchDisplayed; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: settings.columnsDisplayed"></mat-row>
    </lin-table>
  </div>
  <lin-table-toolbar>
    <lin-table-toolbar-button-row class="toolbar-button-block">
      @if (!isClient) {
        <button
          type="button"
          mat-raised-button
          class="submit-button"
          color="accent"
          [routerLink]="createNewDeviceUrl"
          [queryParams]="{ teamId: teamId }"
        >
          {{ 'ADMIN.DEVICES.ADD_NEW_DEVICE' | translate }}
        </button>
      }
      @if (hasPermission(PermissionsSource['DEVICE.DEVICES_LIST.INSTALL']) || !isClient) {
        <button
          class="submit-button"
          type="button"
          mat-raised-button
          color="accent"
          (click)="openInstallationDialog(null, true)"
          data-testid="btn-toolbar-install"
        >
          {{ 'ADMIN.DEVICES.INSTALL' | translate }}
        </button>
        <button
          class="submit-button"
          type="button"
          mat-raised-button
          color="accent"
          (click)="openInstallationDialog(null)"
          data-testid="btn-toolbar-uninstall"
        >
          {{ 'ADMIN.DEVICES.UNINSTALL' | translate }}
        </button>
        @if (isAdminOrReseller) {
          <button
            class="submit-button"
            type="button"
            mat-raised-button
            color="accent"
            [disabled]="!selectedDevices.size"
            (click)="openBulkUpdateDialog('contract')"
            data-testid="btn-update-contracts"
          >
            {{ 'ADMIN.DEVICES.UPDATE_CONTRACTS' | translate }}
          </button>
        }
        @if (authService.getCurrentUser().isAdmin()) {
          <button
            class="submit-button"
            type="button"
            mat-raised-button
            color="accent"
            [disabled]="!selectedDevices.size"
            (click)="openBulkUpdateDialog('ownership')"
            data-testid="btn-update-ownerships"
          >
            {{ 'ADMIN.DEVICES.UPDATE_OWNERSHIPS' | translate }}
          </button>
        }
      }

      <mat-checkbox formControlName="showUnavailable">{{ 'ADMIN.DEVICES.SHOW_UNAVAILABLE' | translate }}</mat-checkbox>
    </lin-table-toolbar-button-row>
    <mat-paginator linPaginatorDefault></mat-paginator>
  </lin-table-toolbar>
</form>

<lin-table-settings #settings [columns]="columns" [columnsMandatory]="columnsMandatory" [disableExportPDF]="true"></lin-table-settings>
